/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './application_type';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "DeviceComponentDetails": {
                "fields": {},
                "nested": {
                  "ApplicationDetails": {
                    "fields": {
                      "applicationType": {
                        "type": ".squareup.connect.v2.ApplicationType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "version": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "sessionLocation": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "deviceCodeId": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "pushToken": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "deviceCodeName": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "appBundleId": {
                        "type": "string",
                        "id": 7,
                        "rule": "optional"
                      },
                      "applicationState": {
                        "type": ".squareup.connect.v2.DeviceComponentDetails.ApplicationDetails.ApplicationState",
                        "id": 8,
                        "rule": "optional"
                      },
                      "updatedAt": {
                        "type": "string",
                        "id": 9,
                        "rule": "optional"
                      },
                      "deviceProfileId": {
                        "type": "string",
                        "id": 10,
                        "rule": "optional"
                      },
                      "modeId": {
                        "type": "string",
                        "id": 11,
                        "rule": "optional"
                      },
                      "superposEnabled": {
                        "type": "bool",
                        "id": 12,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "merchantLoggedInSessionId": {
                        "type": "string",
                        "id": 13,
                        "rule": "optional"
                      },
                      "appLifetimeSessionId": {
                        "type": "string",
                        "id": 14,
                        "rule": "optional"
                      },
                      "clientUpdaterImplVersion": {
                        "type": ".squareup.connect.v2.DeviceComponentDetails.ApplicationDetails.ClientUpdaterImplVersion",
                        "id": 15,
                        "rule": "optional",
                        "options": {
                          "default": "V1"
                        }
                      },
                      "inactive": {
                        "type": "bool",
                        "id": 16,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "modeName": {
                        "type": "string",
                        "id": 17,
                        "rule": "optional"
                      },
                      "employeeId": {
                        "type": "string",
                        "id": 18,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ApplicationState": {
                        "values": {
                          "APPLICATION_STATE_INVALID_TYPE": 0,
                          "BACKGROUND": 1,
                          "FOREGROUND": 2,
                          "INITIALIZING": 3,
                          "LOGGED_OUT": 4
                        }
                      },
                      "ClientUpdaterImplVersion": {
                        "values": {
                          "V1": 0,
                          "IOS_V2": 2
                        }
                      }
                    }
                  },
                  "CardReaderDetails": {
                    "fields": {
                      "version": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "cardReaderStatus": {
                        "type": ".squareup.connect.v2.DeviceComponentDetails.CardReaderDetails.CardReaderStatus",
                        "id": 2,
                        "rule": "optional"
                      },
                      "cardReaderType": {
                        "type": ".squareup.connect.v2.DeviceComponentDetails.CardReaderDetails.CardReaderType",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "CardReaderStatus": {
                        "values": {
                          "CARD_READER_STATUS_INVALID_TYPE": 0,
                          "DISCONNECTED": 1,
                          "CONNECTED": 2,
                          "READY": 3,
                          "TAMPERED": 4,
                          "UPDATING": 5,
                          "CARD_SLOT_DISABLED": 6,
                          "CARD_SLOT_MAYBE_FAULTY": 7
                        }
                      },
                      "CardReaderType": {
                        "values": {
                          "CARD_READER_INVALID_TYPE": 0,
                          "EMBEDDED": 1,
                          "TERMINAL_GEN1_V1": 2,
                          "TERMINAL_GEN1_V2": 3,
                          "REGISTER_GEN1_V1": 4,
                          "REGISTER_GEN1_V2": 5,
                          "STAND_GEN1_V1": 6,
                          "STAND_GEN1_V2": 7,
                          "STAND_GEN1_V3": 8,
                          "STAND_GEN1_V4": 9,
                          "STAND_GEN1_V5": 10,
                          "STAND_GEN2_V1": 11,
                          "STAND_GEN2_V2": 12,
                          "AUDIO_SWIPE_GEN1_V1": 13,
                          "LIGHTNING_SWIPE_GEN1_V1": 14,
                          "AUDIO_DIP_GEN1_V1": 15,
                          "TAPDIP_GEN1_V1": 16,
                          "TAPDIP_GEN1_V2": 17,
                          "TAPDIP_GEN1_V3": 18,
                          "TAPDIP_GEN2_V1": 19,
                          "TERMINAL_GEN2_V1": 20,
                          "HANDHELD_GEN1_V1": 21,
                          "REGISTER_GEN1_V3": 22,
                          "REGISTER_GEN2_V1": 23
                        }
                      }
                    }
                  },
                  "BatteryDetails": {
                    "fields": {
                      "visiblePercent": {
                        "type": "int32",
                        "id": 1,
                        "rule": "optional"
                      },
                      "externalPower": {
                        "type": ".squareup.connect.v2.DeviceComponentDetails.ExternalPower",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "WiFiDetails": {
                    "fields": {
                      "active": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "ssid": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "ipAddressV4": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "secureConnection": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "signalStrength": {
                        "type": ".squareup.connect.v2.DeviceComponentDetails.Measurement",
                        "id": 5,
                        "rule": "optional"
                      },
                      "macAddress": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  },
                  "EthernetDetails": {
                    "fields": {
                      "active": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "ipAddressV4": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "macAddress": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "PrinterDetails": {
                    "fields": {
                      "printerType": {
                        "type": ".squareup.connect.v2.DeviceComponentDetails.PrinterDetails.PrinterType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "paperWidth": {
                        "type": "uint32",
                        "id": 2,
                        "rule": "optional"
                      },
                      "isDefaultWidth": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "PrinterType": {
                        "values": {
                          "PRINTER_INVALID_TYPE": 0,
                          "RECEIPT_PRINTER": 1,
                          "KITCHEN_PRINTER": 2,
                          "LABEL_PRINTER": 3
                        }
                      }
                    }
                  },
                  "ScaleDetails": {
                    "fields": {
                      "selectedWeightUnit": {
                        "type": ".squareup.connect.v2.DeviceComponentDetails.WeightUnit",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "BarcodeScannerDetails": {
                    "fields": {
                      "supportsTwoDimensionalCodes": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "ScannerScaleDetails": {
                    "fields": {
                      "selectedWeightUnit": {
                        "type": ".squareup.connect.v2.DeviceComponentDetails.WeightUnit",
                        "id": 1,
                        "rule": "optional"
                      },
                      "supportsTwoDimensionalCodes": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "USBInterfaceDetails": {
                    "fields": {
                      "portNumber": {
                        "type": "int32",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "BluetoothInterfaceDetails": {
                    "fields": {
                      "signalStrength": {
                        "type": ".squareup.connect.v2.DeviceComponentDetails.Measurement",
                        "id": 1,
                        "rule": "optional"
                      },
                      "macAddress": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "NetworkInterfaceDetails": {
                    "fields": {
                      "ipAddressV4": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "macAddress": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "AirPrintInterfaceDetails": {
                    "fields": {
                      "url": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "CellularDataDetails": {
                    "fields": {
                      "signalStrength": {
                        "type": ".squareup.connect.v2.DeviceComponentDetails.Measurement",
                        "id": 1,
                        "rule": "optional"
                      },
                      "cellularConnectionType": {
                        "type": ".squareup.connect.v2.DeviceComponentDetails.CellularDataDetails.CellularConnectionType",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "CellularConnectionType": {
                        "values": {
                          "CELLULAR_CONNECTION_INVALID_TYPE": 0,
                          "CELLULAR_CONNECTION_TYPE_2G": 1,
                          "CELLULAR_CONNECTION_TYPE_3G": 2,
                          "CELLULAR_CONNECTION_TYPE_4G": 3,
                          "CELLULAR_CONNECTION_TYPE_5G": 4,
                          "CELLULAR_CONNECTION_TYPE_EDGE": 5,
                          "CELLULAR_CONNECTION_TYPE_HSPA": 6
                        }
                      }
                    }
                  },
                  "StandDetails": {
                    "fields": {
                      "version": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "InternalScannerDetails": {
                    "fields": {
                      "enabled": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "ShopDetails": {
                    "fields": {
                      "orderId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "ThirdPartyDeviceDetails": {
                    "fields": {
                      "thirdPartyId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "ExternalPower": {
                    "values": {
                      "EXTERNAL_POWER_INVALID_TYPE": 0,
                      "AVAILABLE_CHARGING": 1,
                      "AVAILABLE_NOT_IN_USE": 2,
                      "UNAVAILABLE": 3,
                      "AVAILABLE_INSUFFICIENT": 4
                    }
                  },
                  "Measurement": {
                    "fields": {
                      "value": {
                        "type": "int32",
                        "id": 1,
                        "rule": "optional"
                      },
                      "unit": {
                        "type": ".squareup.connect.v2.DeviceComponentDetails.Unit",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "Unit": {
                    "values": {
                      "UNIT_INVALID_TYPE": 0,
                      "SIGNAL_BARS": 1,
                      "RSSI": 2
                    }
                  },
                  "WeightUnit": {
                    "values": {
                      "WEIGHT_UNIT_INVALID_TYPE": 0,
                      "MILLIGRAM": 1,
                      "GRAM": 2,
                      "KILOGRAM": 3,
                      "OUNCE": 4,
                      "POUND": 5
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.ApplicationDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.ApplicationDetails?.nested?.ApplicationState && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.ApplicationDetails?.nested?.ClientUpdaterImplVersion && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.CardReaderDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.CardReaderDetails?.nested?.CardReaderStatus && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.CardReaderDetails?.nested?.CardReaderType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.BatteryDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.WiFiDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.EthernetDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.PrinterDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.PrinterDetails?.nested?.PrinterType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.ScaleDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.BarcodeScannerDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.ScannerScaleDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.USBInterfaceDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.BluetoothInterfaceDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.NetworkInterfaceDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.AirPrintInterfaceDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.CellularDataDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.CellularDataDetails?.nested?.CellularConnectionType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.StandDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.InternalScannerDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.ShopDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.ThirdPartyDeviceDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.ExternalPower && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.Measurement && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.Unit && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceComponentDetails?.nested?.WeightUnit) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DeviceComponentDetails @ squareup/devices/external/component_details.proto at 13:1
 */
export const DeviceComponentDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails');
fixType(DeviceComponentDetails);
Builder.createAndAttachToType(DeviceComponentDetails);
/**
 * SOURCE ApplicationDetails @ squareup/devices/external/component_details.proto at 16:3
 */
DeviceComponentDetails.ApplicationDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.ApplicationDetails');
fixType(DeviceComponentDetails.ApplicationDetails);
Builder.createAndAttachToType(DeviceComponentDetails.ApplicationDetails);
/**
 * last used: 18
 *
 * SOURCE ApplicationState @ squareup/devices/external/component_details.proto at 112:5
 */
DeviceComponentDetails.ApplicationDetails.ApplicationState = $root.lookupEnum('squareup.connect.v2.DeviceComponentDetails.ApplicationDetails.ApplicationState').values;
/**
 * SOURCE ClientUpdaterImplVersion @ squareup/devices/external/component_details.proto at 139:5
 */
DeviceComponentDetails.ApplicationDetails.ClientUpdaterImplVersion = $root.lookupEnum('squareup.connect.v2.DeviceComponentDetails.ApplicationDetails.ClientUpdaterImplVersion').values;
/**
 * SOURCE CardReaderDetails @ squareup/devices/external/component_details.proto at 155:3
 */
DeviceComponentDetails.CardReaderDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.CardReaderDetails');
fixType(DeviceComponentDetails.CardReaderDetails);
Builder.createAndAttachToType(DeviceComponentDetails.CardReaderDetails);
/**
 * SOURCE CardReaderStatus @ squareup/devices/external/component_details.proto at 171:5
 */
DeviceComponentDetails.CardReaderDetails.CardReaderStatus = $root.lookupEnum('squareup.connect.v2.DeviceComponentDetails.CardReaderDetails.CardReaderStatus').values;
/**
 * SOURCE CardReaderType @ squareup/devices/external/component_details.proto at 220:5
 */
DeviceComponentDetails.CardReaderDetails.CardReaderType = $root.lookupEnum('squareup.connect.v2.DeviceComponentDetails.CardReaderDetails.CardReaderType').values;
/**
 * SOURCE BatteryDetails @ squareup/devices/external/component_details.proto at 342:3
 */
DeviceComponentDetails.BatteryDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.BatteryDetails');
fixType(DeviceComponentDetails.BatteryDetails);
Builder.createAndAttachToType(DeviceComponentDetails.BatteryDetails);
/**
 * SOURCE WiFiDetails @ squareup/devices/external/component_details.proto at 356:3
 */
DeviceComponentDetails.WiFiDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.WiFiDetails');
fixType(DeviceComponentDetails.WiFiDetails);
Builder.createAndAttachToType(DeviceComponentDetails.WiFiDetails);
/**
 * SOURCE EthernetDetails @ squareup/devices/external/component_details.proto at 391:3
 */
DeviceComponentDetails.EthernetDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.EthernetDetails');
fixType(DeviceComponentDetails.EthernetDetails);
Builder.createAndAttachToType(DeviceComponentDetails.EthernetDetails);
/**
 * SOURCE PrinterDetails @ squareup/devices/external/component_details.proto at 410:3
 */
DeviceComponentDetails.PrinterDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.PrinterDetails');
fixType(DeviceComponentDetails.PrinterDetails);
Builder.createAndAttachToType(DeviceComponentDetails.PrinterDetails);
/**
 * SOURCE PrinterType @ squareup/devices/external/component_details.proto at 418:5
 */
DeviceComponentDetails.PrinterDetails.PrinterType = $root.lookupEnum('squareup.connect.v2.DeviceComponentDetails.PrinterDetails.PrinterType').values;
/**
 * SOURCE ScaleDetails @ squareup/devices/external/component_details.proto at 438:3
 */
DeviceComponentDetails.ScaleDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.ScaleDetails');
fixType(DeviceComponentDetails.ScaleDetails);
Builder.createAndAttachToType(DeviceComponentDetails.ScaleDetails);
/**
 * SOURCE BarcodeScannerDetails @ squareup/devices/external/component_details.proto at 447:3
 */
DeviceComponentDetails.BarcodeScannerDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.BarcodeScannerDetails');
fixType(DeviceComponentDetails.BarcodeScannerDetails);
Builder.createAndAttachToType(DeviceComponentDetails.BarcodeScannerDetails);
/**
 * SOURCE ScannerScaleDetails @ squareup/devices/external/component_details.proto at 457:3
 */
DeviceComponentDetails.ScannerScaleDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.ScannerScaleDetails');
fixType(DeviceComponentDetails.ScannerScaleDetails);
Builder.createAndAttachToType(DeviceComponentDetails.ScannerScaleDetails);
/**
 * SOURCE USBInterfaceDetails @ squareup/devices/external/component_details.proto at 472:3
 */
DeviceComponentDetails.USBInterfaceDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.USBInterfaceDetails');
fixType(DeviceComponentDetails.USBInterfaceDetails);
Builder.createAndAttachToType(DeviceComponentDetails.USBInterfaceDetails);
/**
 * SOURCE BluetoothInterfaceDetails @ squareup/devices/external/component_details.proto at 481:3
 */
DeviceComponentDetails.BluetoothInterfaceDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.BluetoothInterfaceDetails');
fixType(DeviceComponentDetails.BluetoothInterfaceDetails);
Builder.createAndAttachToType(DeviceComponentDetails.BluetoothInterfaceDetails);
/**
 * SOURCE NetworkInterfaceDetails @ squareup/devices/external/component_details.proto at 495:3
 */
DeviceComponentDetails.NetworkInterfaceDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.NetworkInterfaceDetails');
fixType(DeviceComponentDetails.NetworkInterfaceDetails);
Builder.createAndAttachToType(DeviceComponentDetails.NetworkInterfaceDetails);
/**
 * SOURCE AirPrintInterfaceDetails @ squareup/devices/external/component_details.proto at 512:3
 */
DeviceComponentDetails.AirPrintInterfaceDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.AirPrintInterfaceDetails');
fixType(DeviceComponentDetails.AirPrintInterfaceDetails);
Builder.createAndAttachToType(DeviceComponentDetails.AirPrintInterfaceDetails);
/**
 * SOURCE CellularDataDetails @ squareup/devices/external/component_details.proto at 521:3
 */
DeviceComponentDetails.CellularDataDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.CellularDataDetails');
fixType(DeviceComponentDetails.CellularDataDetails);
Builder.createAndAttachToType(DeviceComponentDetails.CellularDataDetails);
/**
 * SOURCE CellularConnectionType @ squareup/devices/external/component_details.proto at 534:5
 */
DeviceComponentDetails.CellularDataDetails.CellularConnectionType = $root.lookupEnum('squareup.connect.v2.DeviceComponentDetails.CellularDataDetails.CellularConnectionType').values;
/**
 * SOURCE StandDetails @ squareup/devices/external/component_details.proto at 547:3
 */
DeviceComponentDetails.StandDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.StandDetails');
fixType(DeviceComponentDetails.StandDetails);
Builder.createAndAttachToType(DeviceComponentDetails.StandDetails);
/**
 * SOURCE InternalScannerDetails @ squareup/devices/external/component_details.proto at 556:3
 */
DeviceComponentDetails.InternalScannerDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.InternalScannerDetails');
fixType(DeviceComponentDetails.InternalScannerDetails);
Builder.createAndAttachToType(DeviceComponentDetails.InternalScannerDetails);
/**
 * SOURCE ShopDetails @ squareup/devices/external/component_details.proto at 566:3
 */
DeviceComponentDetails.ShopDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.ShopDetails');
fixType(DeviceComponentDetails.ShopDetails, {
  orderId: {
    required: true
  }
});
Builder.createAndAttachToType(DeviceComponentDetails.ShopDetails);
/**
 * SOURCE ThirdPartyDeviceDetails @ squareup/devices/external/component_details.proto at 575:3
 */
DeviceComponentDetails.ThirdPartyDeviceDetails = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.ThirdPartyDeviceDetails');
fixType(DeviceComponentDetails.ThirdPartyDeviceDetails, {
  thirdPartyId: {
    required: true
  }
});
Builder.createAndAttachToType(DeviceComponentDetails.ThirdPartyDeviceDetails);
/**
 * --
 * @desc An enum for ExternalPower.
 * --
 *
 * SOURCE ExternalPower @ squareup/devices/external/component_details.proto at 587:3
 */
DeviceComponentDetails.ExternalPower = $root.lookupEnum('squareup.connect.v2.DeviceComponentDetails.ExternalPower').values;
/**
 * --
 * @desc A value qualified by unit of measure.
 * --
 *
 * SOURCE Measurement @ squareup/devices/external/component_details.proto at 616:3
 */
DeviceComponentDetails.Measurement = $root.lookupType('squareup.connect.v2.DeviceComponentDetails.Measurement');
fixType(DeviceComponentDetails.Measurement);
Builder.createAndAttachToType(DeviceComponentDetails.Measurement);
/**
 * --
 * @desc A enum representing units to qualify measures.
 * --
 *
 * SOURCE Unit @ squareup/devices/external/component_details.proto at 632:3
 */
DeviceComponentDetails.Unit = $root.lookupEnum('squareup.connect.v2.DeviceComponentDetails.Unit').values;
/**
 * --
 * @desc A enum representing weight units
 * --
 *
 * SOURCE WeightUnit @ squareup/devices/external/component_details.proto at 643:3
 */
DeviceComponentDetails.WeightUnit = $root.lookupEnum('squareup.connect.v2.DeviceComponentDetails.WeightUnit').values;